// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cart__donations-title{margin-bottom:.35rem}.cart__donations-button{margin-top:.75rem}.cart__donations-button.active{background:var(--blush)}.cart__donations-footer{padding-top:.5rem;display:flex;justify-content:space-between;align-items:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
